import React from 'react';
import Modal from '../Modal';

const ConfirmDialog = ({
  isOpen,
  title = 'Potwierdź operację',
  message,
  detail,
  confirmLabel = 'Usuń',
  cancelLabel = 'Anuluj',
  danger = true,
  onConfirm,
  onCancel
}) => (
  <Modal isOpen={ isOpen } onClose={ onCancel } title={ title }>
    <p className="mb-2" style={ { whiteSpace: 'pre-line' } }>{message}</p>
    {detail && <p className="text-muted small mb-0" style={ { whiteSpace: 'pre-line' } }>{detail}</p>}

    <div className="d-flex gap-2 justify-content-end mt-4">
      <button type="button" className="btn btn-secondary" onClick={ onCancel }>
        <i className="fas fa-times me-2"></i>
        {cancelLabel}
      </button>
      <button
        type="button"
        className={ `btn ${danger ? 'btn-danger' : 'btn-primary'}` }
        onClick={ onConfirm }
      >
        <i className={ `fas ${danger ? 'fa-trash' : 'fa-check'} me-2` }></i>
        {confirmLabel}
      </button>
    </div>
  </Modal>
);

export default ConfirmDialog;
